import { createRouter, createWebHashHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

import Login from '@/pages/login/Login.vue';
import AnnounceModal from '@/components/announce-modal/AnnounceModal.vue';
import OfferSheet from '@/components/offer-sheet/OfferSheet.vue';
import SettlementModal from '@/components/settlement-modal/SettlementModal.vue';
import { useRootStore } from '@/stores/root';
import WidgetConfigIndex from '@/components/widget/WidgetConfigIndex.vue';
import WidgetConfigNew from '@/components/widget/WidgetConfigNew.vue';
import WidgetConfigEdit from '@/components/widget/WidgetConfigEdit.vue';
import UserAccountIndex from '@/pages/user-account/UserAccountIndex.vue';
import UserAccountNew from '@/pages/user-account/UserAccountNew.vue';
import UserAccountEdit from '@/pages/user-account/UserAccountEdit.vue';
import VenueIndex from '@/pages/venues/VenueIndex.vue';
import VenueNew from '@/pages/venues/VenueNew.vue';
import VenueEdit from '@/pages/venues/VenueEdit.vue';
import RoleIndex from '@/pages/team-roles/RoleIndex.vue';
import RoleNew from '@/pages/team-roles/RoleNew.vue';
import RoleEdit from '@/pages/team-roles/RoleEdit.vue';
import WhitelabelIndex from './pages/whitelabel/WhitelabelIndex.vue';
import WhitelabelNew from './pages/whitelabel/WhitelabelNew.vue';
import WhitelabelEdit from './pages/whitelabel/WhitelabelEdit.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/settings/widgets',
    name: 'WidgetConfigIndex',
    component: WidgetConfigIndex,
  },
  {
    path: '/settings/widgets/new',
    name: 'WidgetConfigNew',
    component: WidgetConfigNew,
  },
  {
    path: '/settings/widgets/duplicate/:widgetId',
    name: 'WidgetConfigDuplicate',
    component: WidgetConfigNew,
  },
  {
    path: '/settings/widgets/edit/:widgetId',
    name: 'WidgetConfigEdit',
    component: WidgetConfigEdit,
  },
  {
    path: '/events/:eventId/announce',
    name: 'EventAnnounceModal',
    components: {
      SideModal: AnnounceModal,
    },
    meta: { widthClass: 'max-w-216 w-full', disableScroll: true },
  },
  {
    path: '/offer-sheets/:offerSheetsId',
    name: 'OfferSheet',
    components: {
      SideModal: OfferSheet,
    },
    meta: { widthClass: 'w-full' },
  },
  {
    path: '/event-artists/:eventArtistId/settlements/:settlementId',
    name: 'ArtistSettlementSheet',
    components: {
      SideModal: SettlementModal,
    },
  },
  {
    path: '/settings/team',
    name: 'UserAccountIndex',
    component: UserAccountIndex,
  },
  {
    path: '/settings/team/new',
    name: 'UserAccountNew',
    component: UserAccountNew,
  },
  {
    path: '/settings/team/:userId/edit',
    name: 'UserAccountEdit',
    component: UserAccountEdit,
  },

  {
    path: '/settings/venues',
    name: 'VenueIndex',
    component: VenueIndex,
  },

  {
    path: '/settings/venues/new',
    name: 'VenueNew',
    component: VenueNew,
  },

  {
    path: '/settings/venues/:venueId/edit',
    name: 'VenueEdit',
    component: VenueEdit,
  },

  {
    path: '/settings/team_roles',
    name: 'RoleIndex',
    component: RoleIndex,
  },

  {
    path: '/settings/team_roles/new',
    name: 'RoleNew',
    component: RoleNew,
  },

  {
    path: '/settings/team_roles/:roleId/edit',
    name: 'RoleEdit',
    component: RoleEdit,
  },

  {
    path: '/whitelabel',
    name: 'WhitelabelIndex',
    component: WhitelabelIndex,
  },
  {
    path: '/whitelabel/new',
    name: 'WhitelabelNew',
    component: WhitelabelNew,
  },
  {
    path: '/whitelabel/:whitelabelId/edit',
    name: 'WhitelabelEdit',
    component: WhitelabelEdit,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.afterEach(to => {
  const rootStore = useRootStore();
  rootStore.SET_CURRENT_ROUTE(to);
});

export default router;
